import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Member from './pages/member';
import Contact from './pages/contact';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/member-list" element={<Member />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

export default App;
